import { render, staticRenderFns } from "./PromotionsField.vue?vue&type=template&id=71189f82"
import script from "./PromotionsField.vue?vue&type=script&lang=js"
export * from "./PromotionsField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports